"use strict";

var ensureValue   = require("./valid-value")
  , stringifiable = require("./validate-stringifiable");

module.exports = function (value) { return stringifiable(ensureValue(value)); };



//////////////////
// WEBPACK FOOTER
// ./node_modules/es5-ext/object/validate-stringifiable-value.js
// module id = 237
// module chunks = 0